import React from "react";
import "./PracticeModeProgressBar.css";
import images from "../../../../../utilities/images/images";

const PracticeModeProgressBar = ({ totalQuestions, streak }) => {
  const progress = streak?.progress || []; // may be empty
  const maxStreak = streak?.maxStreak;
  const message = streak?.progressive_message;

  return (
    <div className="practice-progress-container">
      {/* Header */}
      <div className="practice-progress-header">
        <span className="practice-progress-title">Your Streak</span>
        <span className="practice-progress-count">
          {maxStreak?.count || 0} in a Row <img src={images.streakfire_icon} alt="fire"className="streak-fire-icon" />
        </span>
      </div>

      {/* Progress Bar */}
      <div className="practice-progress-bar">
        {Array.from({ length: totalQuestions }).map((_, index) => {
          let status = "empty";

          if (index < progress.length) {
            status = progress[index] ? "correct" : "wrong";
          }

          return (
            <span
              key={index}
              className={`practice-progress-segment ${status}`}
            />
          );
        })}
      </div>

      {/* Message (only after save) */}
      {message && (
        <div
          className="practice-progress-message"
          style={{ backgroundColor: message.bg_colour }}
        >
          <span className="emoji">{message.emoji}</span>
          <span className="text">{message.text}</span>
        </div>
      )}
    </div>
  );
};

export default PracticeModeProgressBar;
